import { isBrowser } from 'browser-or-node';
export const getBasicAuthString = (basicAuth) => {
    let authString = '';
    if (basicAuth.username) {
        authString += basicAuth.username;
    }
    authString += ':';
    if (basicAuth.password) {
        authString += basicAuth.password;
    }
    /**
     * Not ideal, but this is used in service-providers which is imported into both the client and the api.
     */
    return isBrowser ? window.btoa(authString) : Buffer.from(authString).toString('base64');
};
